import { FilterAction, UPDATE_FILTERS, filtersPayload } from "../actions";


const initialState = [];

export const localStorageFiltersLocation = 'global-filters';
export const filtersInitializer = (initialValue = initialState) =>
  JSON.parse(localStorage.getItem(localStorageFiltersLocation)) || initialValue;

export const filtersReducer = (state: filtersPayload[], action: FilterAction) => {
  const newState = state.find(
    item =>
      item.pageName === action.payload.pageName && item.environment === action.payload.environment
  );
  switch (action.type) {
    case UPDATE_FILTERS:
      return newState
        ? state.map(item => {
            return item.pageName === action.payload.pageName
              ? {
                  ...action.payload
                }
              : item;
          })
        : [...state, { ...action.payload }];
    default:
      return state;
  }
};